import { useEffect } from "react";

// Top-clicked next-routes from the homepage. We prefetch their chunks during
// browser idle time after first paint so the very next click feels instant
// without inflating the initial bundle.
const TARGETS = [
  () => import("@/pages/Pricing"),
  () => import("@/pages/Compare"),
  () => import("@/pages/WorksWithEpic"),
  () => import("@/pages/CompareAll"),
  () => import("@/pages/Modules"),
];

export default function RoutePrefetcher() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    let cancelled = false;
    const ric =
      window.requestIdleCallback ||
      ((cb) => setTimeout(() => cb({ didTimeout: false, timeRemaining: () => 50 }), 1500));

    const run = () => {
      if (cancelled) return;
      // Fire and forget — failure is silent (chunks just lazy-load on click later).
      TARGETS.forEach((load) => { try { load(); } catch (_) {} });
    };

    const id = ric(run, { timeout: 4000 });
    return () => {
      cancelled = true;
      if (window.cancelIdleCallback && typeof id === "number") window.cancelIdleCallback(id);
    };
  }, []);

  return null;
}
